import { useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setUpperPopup } from '../store/reducers/general'
import { uploadFile } from '../services/upload'
import { videoService } from '../services/video'
import { useQueryClient } from '@tanstack/react-query'
import { getNextMembers } from '../services/util'
import { useNavigate } from 'react-router-dom'

export function Create() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const user = useSelector(state => state.user)
    const { currentTeam } = user
    const location = useRef()
    const [titles, setTitles] = useState(['', '', ''])
    const exampleVideoLink = useRef()
    const description = useRef()
    const thumbnailDescription = useRef()
    const thumbnailInput = useRef()
    const [thumbnail, setThumbnail] = useState('')
    const nextMembers = useRef(getNextMembers(currentTeam, user._id))
    const nextMember = useRef(null)
    const roles = currentTeam?.members?.find(member => member._id === user._id)?.roles || []

    const createVideo = async (ev) => {
        try {
            ev.preventDefault()
            if (!thumbnailInput.current.files?.[0] && !thumbnailDescription.current.value) return dispatch(setUpperPopup('fill-thumbnail-or-description'))
            const nextSteps = ev.nativeEvent.submitter.name === 'forward-to-selected' ? 'forward-to-' + nextMember.current.value : ev.nativeEvent.submitter.name
            const { secure_url } = thumbnailInput.current.files?.[0] ? await uploadFile(thumbnailInput.current.files[0]) : { secure_url: '' }

            const video = {
                teamId: currentTeam._id,
                createdBy: {
                    _id: user._id,
                    name: user.name,
                    img: user.img,
                    email: user.email,
                },
                ideaMaker: {
                    titles: titles,
                    thumbnails: [secure_url, '', ''],
                    thumbnailDescription: thumbnailDescription.current.value,
                    location: location.current.value || 'לא ידוע',
                    description: description.current.value,
                    exampleVideoLink: exampleVideoLink.current.value,
                    feedback: ''
                }
            }

            await videoService.createVideo(video, currentTeam._id, nextSteps)
            queryClient.invalidateQueries({ queryKey: [currentTeam._id] })
            dispatch(setUpperPopup('video-created'))
            navigate('/')
        }
        catch (error) {
            console.log(error)
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const onImageChange = (ev) => {
        setThumbnail(ev.target.files[0] ? URL.createObjectURL(ev.target.files[0]) : '')
    }

    if (!user._id || !currentTeam._id) return <div className='screen-create'>
        <p>אינך חבר באף צוות עדיין.</p>
        <button onClick={() => navigate('/')}>חזרה לעמוד הבית</button>
    </div>

    const editTitles = (ev) => {
        const { name, value } = ev.target
        let t = [...titles]
        if (value === '' && name !== '2') {
            if (name === '0' && titles[1] && titles[2]) t = [titles[1], titles[2], '']
            else if (name === '0' && titles[1]) t = [titles[1], '', '']
            else if (name === '1' && titles[2]) t = [titles[0], titles[2], '']
            else t[name] = ''
        }
        else t[Number(name)] = value
        setTitles(t)
    }

    return <div className='video-wrapper'>
        {window.innerWidth > 1200 && <div className="video-side-bar">
            <div className="back" onClick={() => navigate('/')}>
                <span className="material-symbols-outlined">chevron_right</span>
                <p>למסך הבית</p>
            </div>
            {titles[0] && <h3 className="title">{titles[0]}</h3>}
            {thumbnail && <img src={thumbnail} alt="thumbnail" className="thumbnail" />}
            <div className="btn">
                <span className="material-symbols-outlined">lightbulb</span>
                <p>רעיון</p>
            </div>
        </div>}
        <section className='video fade-down'>
            <h1 className='white'>הצע רעיון חדש לסרטון</h1>
            <form onSubmit={createVideo}>
                <div className='idea-maker'>

                    <div className='right'>
                        <h3>כותרות</h3>
                        <div className="numbered">
                            <p>1</p>
                            <input maxLength={70} type="text" placeholder="כותרת 1" className="simple-input title" value={titles[0]} onChange={editTitles} name="0" />
                        </div>
                        {titles[0] && <div className="numbered">
                            <p>2</p>
                            <input maxLength={70} type="text" placeholder="כותרת 2" className="simple-input title" value={titles[1]} onChange={editTitles} name="1" />
                        </div>}
                        {titles[1] && <div className="numbered">
                            <p>3</p>
                            <input maxLength={70} type="text" placeholder="כותרת 3" className="simple-input title" value={titles[2]} onChange={editTitles} name="2" />
                        </div>}

                        <h3>תיאור</h3>
                        <textarea required ref={description} className='area' placeholder="תיאור קצר על הסרטון" />

                        <h3>סרטון השראה</h3>
                        <input style={{ flex: 0, maxWidth: 'unset' }} type='url' placeholder='לינק לסרטון השראה' ref={exampleVideoLink} />
                    </div>


                    <div className='left'>
                        <h3>מיקום</h3>
                        <input style={{ flex: 0 }} type="text" placeholder="מיקום" className="simple-input" ref={location} />

                        <h3>טאמבנייל</h3>
                        <div className='thumbnails-click clickable'>
                            <input type="file" className="non-appear" accept="image/*" id='0' ref={thumbnailInput} onChange={onImageChange} />
                            <label htmlFor='0' className="main-thumbnail clickable">
                                {thumbnail ? <img src={thumbnail} alt='thumbnail1' /> :
                                    <span className="material-symbols-outlined">add</span>}
                            </label>
                        </div>

                        <h3>תיאור טאמבנייל</h3>
                        <textarea className='area' ref={thumbnailDescription} />
                    </div>
                </div>

                <div className='buttons' style={{ marginTop: '30px' }}>
                    <div className='gray' onClick={() => navigate('/')}>חזור</div>
                    {roles.includes('admin') || roles.includes('ideaMaker') && <button name='save-only' className='save'>שמור שינויים</button>}
                    {nextMembers.current && nextMembers.current.length > 0 ?
                        <div className='next-wrapper'>
                            <select ref={nextMember}>
                                {nextMembers.current.map(member => <option value={member._id} key={member._id}>{member.name}</option>)}
                            </select>
                            <button className='green' name='forward-to-selected'>העבר</button>
                        </div> :
                        <button className='green'>העלה לבדיקה</button>}
                </div>
            </form>
        </section>
    </div>
} 